import * as React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core'
import ShopLocationsTableCore from 'components/container/page/location/ShopLocationTableCore'
import * as styles from './dialog.module.css'

const ShopLocationListDialog = ({open, onClose, locations}) => {
  const { t } = useTranslation()
  return (
    <Dialog
      className={styles.dialog}
      open={open}
      onClose={onClose}
    >
      <DialogTitle className={styles.titleTxt}>{t('jetso.shops')}</DialogTitle>
      <DialogContent>
        <ShopLocationsTableCore
          className={styles.table}
          mode='view'
          data={locations ?? []}
        />
      </DialogContent>
      <DialogActions>
        <Button className="mui-dialog-btn-nok" onClick={onClose}>
          {t('common.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ShopLocationListDialog